module.exports = __webpack_public_path__ + "img/gear.2526e094.svg";